/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsDelete } from "../../funcs/accountsDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.DeleteApiWorkspaceServiceV1AccountsIdRequest$inboundSchema,
};

export const tool$accountsDelete: ToolDefinition<typeof args> = {
  name: "accounts_delete",
  description: `Delete account`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await accountsDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
